import { apiServer } from 'settings/web-services/api';
import { GET_SHOWING_AGGREGATE_ARCHIVE_COUNT_BY_USER_ID } from 'app-constants/endpoints';

export const getShowingsAggregateByUserId = ({ id, filters }) =>
  apiServer.get(`/showing/showing-aggregate/${id}`, { params: filters });

export const getShowingsAggregateArchiveCountByUserId = ({ id, filters, ...cfg }) =>
  apiServer.get(GET_SHOWING_AGGREGATE_ARCHIVE_COUNT_BY_USER_ID(id, filters), cfg);
